export const isValidDate = (value: string): boolean => {
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
    return false; // Ensure the format is strictly DD.MM.YYYY
  }

  const [day, month, year] = value.split(".").map(Number);

  if (month < 1 || month > 12) return false; // Month must be between 1 and 12
  if (day < 1 || day > 31) return false; // Day must be between 1 and 31 (general check)
  if (year < 1900 || year > 2100) return false; // Year must be reasonable

  // Check if the date is valid
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  );
};

export const formatDateToShortString = (dateString: string) => {
  const [day, month, year] = dateString.split(".");
  const date = new Date(`${year}-${month}-${day}`);

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
